import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NotificationsIcon } from '~/shared/components/Icons/Icons';
import type { NotificationUrgency, UrgencyMessageKey } from './types';
import { URGENCY_CONFIG } from './utils/severietyMapping';

export function NotificationUrgencyMessageBox({
  urgency,
}: {
  urgency: NotificationUrgency;
}) {
  const { t } = useTranslation();
  const config = URGENCY_CONFIG[urgency];

  if (!config.urgencyMessageKey) {
    return null;
  }

  return (
    <Box
      sx={{
        mt: 4,
        p: 2,
        borderRadius: '6px',
        backgroundColor: config.urgencyBgColor,
        border: '1px solid',
        borderColor: config.urgencyBorderColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <NotificationsIcon
        sx={{ fontSize: 18, color: config.urgencyTextColor }}
      />
      <Typography
        variant="body2"
        sx={{
          color: config.urgencyTextColor,
          fontWeight: 500,
        }}
      >
        {
          (
            {
              high: t('notificationDetails.urgencyMessage.high'),
              mid: t('notificationDetails.urgencyMessage.mid'),
            } as Record<UrgencyMessageKey, string>
          )[config.urgencyMessageKey]
        }
      </Typography>
    </Box>
  );
}
